import React from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { Icon, Paragraph } from 'src/components'
import { faSort } from '@fortawesome/free-solid-svg-icons'

interface IPOSManualSortCategoriesProps {
  categories: ICategoryNode[]
  setCategories: (categories: ICategoryNode[]) => void
  sortType: string
  onSortChildren?: (toSort: ICategoryChildrenToSort) => void
}
export const POSManualSortCategories = ({
  categories,
  setCategories,
  sortType,
  onSortChildren,
}: IPOSManualSortCategoriesProps) => {
  const isDraggable = sortType === 'custom'

  const onDragEnd = (result: any) => {
    // Si no hay destino válido, no hacer nada
    if (!result.destination) return

    // Si no cambió de posición, no hacer nada
    if (result.destination.index === result.source.index) return

    // Crear una copia del arreglo
    const items = Array.from(categories)

    // Remover el elemento arrastrado
    const [reorderedItem] = items.splice(result.source.index, 1)

    // Insertar el elemento en la nueva posición
    items.splice(result.destination.index, 0, reorderedItem)

    // Actualizar el estado con el nuevo orden
    setCategories(items)
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="categories">
        {provided => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="categories-list">
            {categories.map((category, index) => {
              const children = category.children || []
              const haveChildren = children.length > 0

              return (
                <Draggable
                  key={category.id.toString()}
                  draggableId={category.id.toString()}
                  index={index}
                  isDragDisabled={!isDraggable}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`category-item ${
                        snapshot.isDragging ? 'dragging' : ''
                      } ${sortType === 'custom' ? 'draggable' : ''}`}>
                      <div className={'space-between'}>
                        <Paragraph bold>{category.name}</Paragraph>
                        {isDraggable && haveChildren && (
                          <Icon
                            icon={faSort}
                            color={'primary'}
                            tooltip={'Ordenar sub categorías manualmente'}
                            onClick={() => onSortChildren({ category, children })}
                          />
                        )}
                      </div>
                      {haveChildren && (
                        <div className={'column'}>
                          {children.map(child => (
                            <Paragraph key={child.id} dim>
                              - {child.name}
                            </Paragraph>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </Draggable>
              )
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}
